const region = "us-west-1";
const secretName = "co811-attachments-keys";
const appBucketName = "co811-attachments-app";
const attachmentsBucketName = "co811-attachments";
const lambdaSourceFileNameWithoutExtension = "signUploadUrlLambda";
const signingUrlLocatorFileName = "signingUrl.txt";
const accountNumber = "397756701048";
const userName = "co811-attachments-user";

const AWS = require("aws-sdk");

const iam = new AWS.IAM({ apiVersion: "2010-05-08" });
const s3 = new AWS.S3({ apiVersion: "2006-03-01" });

const lambda = new AWS.Lambda({
  apiVersion: "2015-03-31",
  region
});

const apiGateway = new AWS.APIGateway({
  apiVersion: "2015-07-09",
  region
});

const secrets = new AWS.SecretsManager({
  region
});

module.exports = {
  region,
  appBucketName,
  attachmentsBucketName,
  lambdaSourceFileNameWithoutExtension,
  signingUrlLocatorFileName,
  accountNumber,
  userName,
  iam,
  s3,
  lambda,
  apiGateway,
  secrets,
  secretName
};
